export enum EmailAccountInfrastructureServiceProvider {
  Google = 'Google',
  Microsoft = 'Microsoft',
  MailDoso = 'MailDoso',
  Inframail = 'InfraMail',
  Azure = 'Azure',
}

export enum EmailInfrastructureStep {
  ChoosePlan = 'choose-plan',
  PurchaseDomains = 'purchase-domains',
  CreateEmailAccounts = 'create-email-accounts',
  ContactDetails = 'contact-details',
  Billing = 'billing',
}

export enum EmailAccountInfrastructurePlanType {
  InboxSetup = 'inbox-setup',
  DomainSetup = 'domain-setup',
  HostSetup = 'host-setup',
}

export enum PlanType {
  Quarterly = 'quarterly',
  AnnualFlexi = 'annualFlexi',
  AnnualFixed = 'annualFixed',
}
